import _chunk from 'lodash/chunk';

import { prophetTypes } from '../types';

import { uploadFiles } from '@/features/files';

export const replaceMessagesWithUploadedFiles = async (
  messages: prophetTypes.Rule['messages'] | prophetTypes.KeywordRule['messages'],
  entityId: string
) => {
  const files = [];
  for (const messagesArray of Object.values(messages)) {
    for (const messages of messagesArray) {
      for (const message of messages) {
        if ('file' in message) {
          files.push(message.file);
        }
      }
    }
  }
  if (!files.length) {
    return messages;
  }
  const filesChunks = _chunk(files, 10);
  const uploadedFilesChunks = await Promise.all(
    filesChunks.map(async (chunk) => {
      const { files } = await uploadFiles({ files: chunk, entityId });
      return files;
    })
  );
  const uploadedFiles = uploadedFilesChunks.flat();
  const result = Object.fromEntries(
    Object.entries(messages).map(([key, messagesArray]) => {
      return [
        key,
        messagesArray.map((messages) => {
          return messages.map((message) => {
            if ('file' in message) {
              const uploadedFile = uploadedFiles.shift();
              if (!uploadedFile) {
                throw new Error('No URL');
              }
              return { type: 'image', url: uploadedFile.url, key: uploadedFile.key };
            }
            return message;
          });
        }),
      ];
    })
  ) as prophetTypes.Rule['messages'];
  if (uploadedFiles.length) {
    throw new Error('Files count mismatch');
  }
  return result;
};

export const extractPageName = (page: prophetTypes.Page) => {
  if ('name' in page.appPage) {
    return page.appPage.name;
  }
  return page.name || 'Unknown';
};

export const extractPageIdentifier = (page: prophetTypes.Page) => {
  if ('phone' in page.appPage) {
    return page.appPage.phone;
  }
  if ('inst' in page.appPage) {
    return page.appPage.inst.id;
  }
  // DEV-2889: show username when phone/inst id are absent (TG pages after phone strip).
  if ('username' in page.appPage && page.appPage.username) {
    return page.appPage.username;
  }
  return undefined;
};
